import React from 'react';
import { FadeIn } from './FadeIn';
export function Bonuses() {
  const bonuses = [{
    title: 'Mapa de Alertas Emocionales',
    desc: 'Aprendé a leer lo que tu adolescente no puede decirte antes de que todo explote.',
    value: '$8.500'
  }, {
    title: 'Guía de Frases que Abren Diálogo',
    desc: '60 frases reales para acercarte sin que se cierre más. Para cada situación específica.',
    value: '$9.000'
  }, {
    title: 'Checklist de Primeros Auxilios para Días Difíciles',
    desc: 'Sabé exactamente qué hacer cuando está sensible, irritable o al borde sin improvisar.',
    value: '$8.000'
  }, {
    title: 'Rutina de 7 Días para Reconectar',
    desc: 'Un plan de microacciones para reconstruir el puente cuando la distancia se instaló.',
    value: '$9.000'
  }];
  return <section className="py-24 relative" data-id="element-11">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-yellow/5 blur-[150px] pointer-events-none" data-id="element-12"></div>

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-13">
        <FadeIn data-id="element-14">
          <div className="text-center mb-16" data-id="element-15">
            <h2 className="text-4xl md:text-6xl font-bold mb-4 text-white" data-id="element-16">
              🎁 4 BONOS ESTRATÉGICOS
            </h2>
            <p className="text-gold text-xl md:text-2xl font-bold uppercase tracking-wider" data-id="element-17">
              SIEMPRE INCLUIDOS
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-18">
          {bonuses.map((bono, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-19">
              <div className="bg-surface p-6 rounded-2xl border border-white/5 flex flex-col md:flex-row md:items-center justify-between gap-4 hover:border-yellow/30 transition-colors" data-id="element-20">
                <div className="flex items-start gap-4" data-id="element-21">
                  <span className="text-2xl" data-id="element-22">🎁</span>
                  <div data-id="element-23">
                    <h3 className="text-lg font-bold text-white mb-1" data-id="element-24">
                      Bono {i + 1}: {bono.title}
                    </h3>
                    <p className="text-gray-400 text-sm" data-id="element-25">{bono.desc}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 md:flex-col md:items-end md:gap-1 shrink-0" data-id="element-26">
                  <span className="text-gray-500 line-through text-sm" data-id="element-27">
                    Valor: {bono.value}
                  </span>
                  <span className="bg-yellow text-background font-bold px-3 py-1 rounded-md text-sm uppercase tracking-wide" data-id="element-28">
                    GRATIS
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-29">
          <div className="text-center p-8 rounded-2xl bg-gradient-to-r from-surface to-surfaceLight border border-yellow/20" data-id="element-30">
            <p className="text-xl md:text-2xl font-medium" data-id="element-31">
              Valor total de los bonos:{' '}
              <span className="line-through text-gray-500" data-id="element-32">$34.500</span>{' '}
              <span className="text-yellow font-bold" data-id="element-33">
                → GRATIS con tu Kit Adulto de Rescate
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}